import React, { useEffect, useState } from "react";
import AdminAppBody from "../../../../../components/admin/AdminAppBody";
import PageHeading from "../../../../../components/admin/common/PageHeading";
import { FaTrash } from "react-icons/fa";
import useApiCallHooks from "../../../../../hooks/useApiCallHooks";
import { toast } from "react-toastify";

const ListGallery = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [gallery, setGallery] = useState([]);

  // Fetch gallery on page load
  useEffect(() => {
    callAPI("get", "admin/case-studie-images");
  }, []);

  // When API response comes, update state
  useEffect(() => {
    if (statusCode === 200) {
      console.log("API Response:", responce);
      setGallery(responce?.data || []);
    }
  }, [responce, statusCode]);

  // Delete image
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;

    await callAPI("delete", `admin/case-studie-images/${id}`);

    if (responce?.success) {
      toast.success("Image deleted successfully");
      setGallery((prev) => prev.filter((item) => item.id !== id));
    } else {
      toast.error("Failed to delete image");
    }
  };

  return (
    <AdminAppBody
      content={
        <div className="container card">
          <PageHeading title="Gallery List" />

          <div className="container">
          

            {Array.isArray(gallery) && gallery.length > 0 && (
              <div className="table-responsive">
                <table className="table table-bordered table-hover align-middle">
                  <thead className="table-dark">
                    <tr>
                      <th>#</th>
                      <th>Image</th>
                      <th>Case Study</th>
                      <th>Status</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gallery.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>
                          <img
                            src={item.image}
                            alt="gallery"
                            style={{
                              width: "100px",
                              height: "70px",
                              objectFit: "cover",
                            }}
                            className="rounded shadow-sm"
                          />
                        </td>
                        <td>{item.case_study?.name || "N/A"}</td>
                        <td>
                          {item.status === 1 ? (
                            <span className="badge bg-success">Active</span>
                          ) : (
                            <span className="badge bg-secondary">Inactive</span>
                          )}
                        </td>
                        <td>{new Date(item.created_at).toLocaleDateString()}</td>
                        <td>
                          <button
                            className="sys-list-table__action delete"
                            onClick={() => handleDelete(item.id)}
                          >
                            <FaTrash /> 
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      }
    />
  );
};

export default ListGallery;
